<template lang="pug">
b-modal(v-model="showModal" :title="'Cancelar paquete ' + packageCode" @ok="onSubmit")
	b-form
		CustomFormGroup(label="Motivo de cancelación" required icon="comment")
			b-form-input(
        v-model="cancelReason"
        :state="$v.$dirty ? !$v.cancelReason.$invalid : null"
        placeholder="Ingresa el motivo de cancelación"
      )
		CustomFormGroup(label="Imagen (opcional)" icon="image")
			ImageInputOptimized(v-model="cancelImages")
</template>

<script>
import CustomFormGroup from '@/components/UI/CustomFormGroup.vue'
import ImageInputOptimized from '@/components/UI/ImageInputOptimized.vue'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    CustomFormGroup,
    ImageInputOptimized
  },
  data() {
    return {
      packageId: null,
      packageCode: null,
      showModal: false,
      cancelReason: '',
      cancelImages: null
    }
  },
  validations: {
    cancelReason: {
      required
    }
  },
  methods: {
    show(packageId, packageCode) {
      this.$v.$reset()
      this.packageId = packageId
      this.packageCode = packageCode
      this.cancelReason = ''
      this.cancelImages = null
      this.showModal = true
    },
    async onSubmit(event) {
      event.preventDefault()
      this.$v.$touch()
      if (this.$v.$invalid) return
      const ok = await this.$bvModal.msgBoxConfirm('¿Está seguro que desea cancelar el paquete?', {
        title: 'Cancelar paquete',
        okVariant: 'outline-danger',
        cancelVariant: 'outline-primary',
        okTitle: 'Aceptar',
        cancelTitle: 'Cancelar'
      })
      if (!ok) return
      try {
        const formData = new FormData()
        formData.append('cancelReason', this.cancelReason)
        formData.append('cancelImages', this.cancelImages)
        await this.$store.dispatch('cancelPackage', { id: this.packageId, data: formData })
        this.$root.$bvToast.toast('Paquete cancelado', {
          title: 'Éxito',
          variant: 'success',
          solid: true
        })
        this.$emit('done')
        this.showModal = false
      } catch (error) {
        console.error(error)
        this.$root.$bvToast.toast('No se pudo cancelar el paquete', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    }
  }
}
</script>